import CONSTANT from '../utils/constants';
import { EVENT, log } from '../common/logger';
import { getApi } from '../utils/api-response-utils';
import { getKey } from '../utils/common';
import { isNull } from '../../../common/src/utils/common';

const numberRegex = /^[0-9a-zA-Z]+$/;
const nameRegex = /^[0-9a-zA-Z ]+$/;
const ifscRegex = /^[A-Za-z]{4}[a-zA-Z0-9]{7}$/;

export const setOptedBankData = data => {
  log({
    eventType: EVENT.BM_BANK_SELECT,
    data: {
      payMode: CONSTANT.BM,
      bankSelected: data.channelName,
      bankCode: data.channelCode,
      mandateBankCode: data.mandateBankCode,
      haslowSuccess: getKey(data, 'data.hasLowSuccess.status', ''),
      lowSuccessMsg: getKey(data, 'data.hasLowSuccess.msg', '')
    }
  });
  return {
    showAccountDetailsScreen: true,
    showBanksScreen: false
  };
};

export const changeBank = () => {
  log({
    eventType: EVENT.BM_CHANGE_BANK_CLICK,
    payMode: CONSTANT.BM
  });
  return {
    showAccountDetailsScreen: false,
    showBanksScreen: true
  };
};

export const setAccountDetails = accountData => {
  const account = {};
  Object.assign(account, accountData);
  if (account.maskedAccountNumber) {
    account.accountNumber = account.maskedAccountNumber;
  }
  return account;
};

export const isBankDetailsEditable = accountData => {
  if (accountData && accountData.accountNumber) {
    return false;
  }
  return true;
};

export const displayConfirmationScreen = () => {
  return {
    showConfirmationScreen: true
  };
};

export const accountInpRestricted = ev => {
  let digit = String.fromCharCode(ev.which);
  if (ev.key !== undefined) {
    digit = ev.key;
  }
  // any other character than alphanumeric
  if (!numberRegex.test(digit)) {
    if (ev.which !== 8 && ev.which !== 9 && ev.which !== 37 && ev.which !== 39) {
      ev.preventDefault();
    }
  }
};

export const nameInpRestricted = ev => {
  let digit = String.fromCharCode(ev.which);
  if (ev.key !== undefined) {
    digit = ev.key;
  }
  // any other character than alphanumeric and space
  if (!nameRegex.test(digit)) {
    if (ev.which !== 8 && ev.which !== 9 && ev.which !== 37 && ev.which !== 39) {
      ev.preventDefault();
    }
  }
};

const validateAuthMode = value => {
  if (!value || value.length < 1) {
    return 'blank';
  }
  return false;
};

export const validateMandateAuthDetails = (authMode, authModeData) => {
  let stateData = {};
  const [invalidAuth] = [validateAuthMode(authMode)];
  if (invalidAuth) {
    stateData = { authModeError: authModeData[invalidAuth] };
  }
  const data = { stateData, submit: false };
  if (!invalidAuth) {
    data.submit = true;
  }
  return data;
};

const validateAccountNumber = value => {
  if (!value || value.length < 1) {
    return 'blank';
  }
  if (
    value.length >= CONSTANT.ACCOUNT_NUMBER_MIN_LENGTH &&
    value.length <= CONSTANT.ACCOUNT_NUMBER_MAX_LENGTH &&
    numberRegex.test(value)
  ) {
    return false;
  }
  return 'invalid';
};

const validateAccountName = value => {
  if (!value || value.length < 1) {
    return 'blank';
  }
  if (
    value.length >= CONSTANT.ACCOUNT_NAME_MIN_LENGTH &&
    value.length <= CONSTANT.ACCOUNT_NAME_MAX_LENGTH &&
    nameRegex.test(value)
  ) {
    return false;
  }
  return 'invalid';
};

const validateAccountIfsc = value => {
  if (!value || value.length < 1) {
    return 'blank';
  }
  if (value.length === CONSTANT.ACCOUNT_IFSC_LENGTH && ifscRegex.test(value)) {
    return false;
  }
  return 'invalid';
};

export const validateAccountDetails = (
  name,
  number,
  ifsc,
  authMode,
  nameData,
  numberData,
  ifscData,
  authModeData
) => {
  let stateData = {};
  const [invaildName, invaildNumber, invaildIfsc, invalidAuth] = [
    validateAccountName(name),
    validateAccountNumber(number),
    validateAccountIfsc(ifsc),
    validateAuthMode(authMode)
  ];
  if (invaildName) {
    stateData = { nameError: nameData[invaildName], isNameError: true };
  } else if (invaildNumber) {
    stateData = { numberError: numberData[invaildNumber], isNumberError: true };
  } else if (invaildIfsc) {
    stateData = { ifscError: ifscData[invaildIfsc], isIfscError: true };
  } else if (invalidAuth) {
    stateData = { authModeError: authModeData[invalidAuth], isAuthModeError: true };
  }
  const data = { stateData, submit: false };
  if (!invaildName && !invaildNumber && !invaildIfsc && !invalidAuth) {
    data.submit = true;
  }
  return data;
};

export const updateInputValue = (ev, currValue, key) => {
  const { value } = ev.target;
  const regex = key === 'accountHolderName' ? nameRegex : numberRegex;
  let stateData = { [key]: currValue };
  if (value === '' || regex.test(value)) {
    stateData = { [key]: value };
  }
  return stateData;
};

export const clearFieldError = type => {
  let stateData = {};
  if (type === 'name') {
    stateData = { nameError: '', isNameError: false };
  } else if (type === 'number') {
    stateData = { numberError: '', isNumberError: false };
  } else if (type === 'ifsc') {
    stateData = { ifscError: '', isIfscError: false };
  } else if (type === 'authMode') {
    stateData = { authModeError: '', isAuthModeError: false };
  }
  return stateData;
};

export const selectIfscFromBank = (key, data, cache) => {
  log({
    eventType: EVENT.BM_FIND_IFSC_CLICK,
    payMode: CONSTANT.BM,
    bankData: data
  });
  // Capitalise all request params
  for (const prop in data) {
    if (data[prop]) {
      data[prop] = data[prop].toUpperCase();
    }
  }
  return new Promise((resolve, reject) => {
    if (!cache.getData(key)) {
      getApi(cache)
        .getIfsc(data)
        .then(res => {
          if (res && res.statusMessage && res.statusMessage === 'SUCCESS' && res.response) {
            const ifscData = res.response;
            cache.setData(key, ifscData);
            resolve(ifscData);
          } else {
            let ifscData = CONSTANT.GENERIC_ERROR;
            if (res && res.statusMessage) {
              ifscData = res.statusMessage;
            }
            reject(ifscData);
          }
        })
        .catch(res => {
          let ifscData = CONSTANT.GENERIC_ERROR;
          if (res && res.statusMessage) {
            ifscData = res.statusMessage;
          }
          reject(ifscData);
        });
    } else {
      resolve(cache.getData(key));
    }
  });
};

export const validateIfscInput = (data, ifscAPIData, cache) => {
  for (const prop in data) {
    if (data[prop]) {
      data[prop] = data[prop].toUpperCase();
    }
  }
  if (data.ifscCode === (ifscAPIData && ifscAPIData.toUpperCase())) {
    return Promise.resolve({ ifscCode: ifscAPIData });
  }
  return new Promise((resolve, reject) => {
    getApi(cache)
      .validateIfsc(data)
      .then(res => {
        if (res && res.statusMessage && res.statusMessage === 'SUCCESS' && res.response) {
          const ifscData = res.response;
          resolve(ifscData);
        } else {
          let ifscData = CONSTANT.GENERIC_ERROR;
          if (res && res.statusMessage) {
            ifscData = res.statusMessage;
          }
          reject(ifscData);
        }
      })
      .catch(res => {
        let ifscData = CONSTANT.GENERIC_ERROR;
        if (res && res.statusMessage) {
          ifscData = res.statusMessage;
        }
        reject(ifscData);
      });
  });
};
export const closeSubsConfirmScreen = () => {
  return { showConfirmationScreen: false, genericError: '', btnDisabled: false };
};

export const subsDateFormat = dateStr => {
  let date = '';
  if (dateStr && typeof date === 'string') {
    date = dateStr.split(' ');
    if (date.length === 6) {
      date = Array.prototype.join.call([date[2], date[1], date[5]], ' ');
    } else {
      date = '';
    }
  }
  return date;
};

export const onConfirmSubmit = (accountDetails, bankData, isSI, cache) => {
  const data = {
    body: {
      paymentMode: CONSTANT.BM,
      mandateAuthMode: accountDetails.mandateAuthMode,
      bankIfsc: accountDetails.ifsc,
      accountType: 'OTHERS',
      userName: accountDetails.accountHolderName,
      bankName: bankData.channelName,
      channelCode: bankData.channelCode
    },
    showLoader: true
  };
  if (accountDetails.ifsc) {
    data.body.bankIfsc = accountDetails.ifsc;
  }
  if (isSI) {
    // in case of smb type (saved mandate bank)
    data.body.upiAccRefId = accountDetails.accRefId;
  } else {
    // in other cases
    data.body.accountNumber = accountDetails.accountNumber;
  }

  return new Promise((resolve, reject) => {
    getApi(cache)
      .pay(data.body)
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        const resultStatus = getKey(err, 'body.resultInfo.resultStatus');
        const errObj = { genericError: CONSTANT.GENERIC_ERROR, btnDisabled: false };
        if (resultStatus && resultStatus === 'F') {
          const resultMsg = getKey(err, 'body.resultInfo.resultMsg');
          errObj.genericError = resultMsg;
        }
        return reject(errObj);
      });
  });
};

export const lastFourAccountNumber = number => {
  if (number) {
    return number.substring(number.length - 4);
  }
  return null;
};

// Keep NET BANKING on top
export const sortAuthModes = modes => {
  if (modes && modes.length) {
    const NBMode = modes.filter(item => item === CONSTANT.NB_AUTH_MODE);
    const otherModes = modes.filter(item => item !== CONSTANT.NB_AUTH_MODE);
    return NBMode.concat(otherModes);
  }
  return [];
};

export const isAmountZero = amt => {
  if (!Number(amt) || Number.isNaN(amt)) {
    return '';
  }
  return amt;
};

export const formatData = data => {
  if (!data) {
    data = [];
  }
  data = data.sort((first, second) => {
    const bankName = first.displayName ? 'displayName' : 'channelName';
    // null check for displayName
    if (!getKey(first, 'displayName', false) || isNull(first.displayName)) {
      first.displayName = '';
    }
    if (!getKey(first, 'channelName', false) || isNull(first.channelName)) {
      first.channelName = '';
    }
    if (!getKey(second, 'displayName', false) || isNull(second.displayName)) {
      second.displayName = '';
    }
    if (!getKey(second, 'channelName', false) || isNull(second.channelName)) {
      second.channelName = '';
    }
    return first[bankName].localeCompare(second[bankName]);
  });

  return data;
};

export const filterBanks = (value, data) => {
  const result = data.filter(record => {
    const bankName = record.displayName ? 'displayName' : 'channelName';
    return record[bankName].toLowerCase().indexOf(value.toLowerCase()) !== -1;
  });
  return result;
};

export const filterByAlphabet = (alphabet, data) => {
  return data.filter(record => {
    const bankName = record[record.displayName ? 'displayName' : 'channelName'].toLowerCase();
    return !!(bankName && bankName.charAt(0) === alphabet.toLowerCase());
  });
};



// WEBPACK FOOTER //
// ./controllers/bank-mandate.js